import { Observable } from '../Observable';
import { noop } from '../util/noop';
export var NEVER = new Observable(noop);
export function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/dist/esm5/internal/observable/never.js
// module id = 439
// module chunks = 0